import { render, staticRenderFns } from "./BusinessJobsList.vue?vue&type=template&id=0d845fcb"
import script from "./BusinessJobsList.vue?vue&type=script&lang=js"
export * from "./BusinessJobsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports